module.exports = __webpack_public_path__ + "static/img/logo.96edce5c.jpg";